import React from 'react';

import { AssignedTeamMember } from 'components/prequalification/prequalification.dto';
import TeamMembers from 'components/prequalification/EntryFormResult/Slides/TeamMembers';
import styles from 'components/prequalification/EntryFormResult/EntryFormResult.module.scss';

interface ActiveIntermediaryProps {
  assignedTeamMember: AssignedTeamMember;
}

const AccountMayExist = ({ assignedTeamMember }: ActiveIntermediaryProps) => {
  return (
    <div>
      <p className={styles.text}>
        An account may exist with the contact information you provided. The account holder will receive an email with
        next steps. Please check your inbox or contact your HFS Representative for assistance.
      </p>
      <TeamMembers
        name={assignedTeamMember.name}
        email={assignedTeamMember.email}
        phone={assignedTeamMember.phone}
        position={assignedTeamMember.position}
        isDefault={assignedTeamMember.isDefault}
      />
    </div>
  );
};

export default AccountMayExist;
